import React from 'react';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {
  Environment,
  WebflowEnvironments,
} from '@packages/systems/core-constants';
import {Atom, Plugins} from '@packages/systems/wfdl';
import withAttribute from './withAttribute';
import {
  DATA_ATTR_NODE_TYPE,
  NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_TOGGLE_CHECKBOX,
} from '@packages/systems/commerce/constants';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {useRuntimeEnvironment} from '@packages/systems/render';

const shouldCheckboxBeChecked = ({
  runtimeEnvironment,
  isBillingAddressOpen,
}: {
  runtimeEnvironment: Environment;
  isBillingAddressOpen: boolean;
}) => {
  const isDesigner = runtimeEnvironment === WebflowEnvironments.DESIGNER;

  if (isDesigner) {
    return !isBillingAddressOpen;
  } else {
    return true;
  }
};

const BillingAddressToggleCheckbox = Atom.createRender(
  ({attributes, classes, context, generateAttributes}) => {
    const runtimeEnvironment = useRuntimeEnvironment();
    const isBillingAddressOpen = context.get('isBillingAddressOpen');
    const checked = shouldCheckboxBeChecked({
      runtimeEnvironment,
      isBillingAddressOpen,
    });

    return (
      <input
        {...generateAttributes(attributes, classes)}
        type="checkbox"
        onChange={() => {}}
        checked={checked}
      />
    );
  }
);

const config = createIntegratedAtom({
  displayName: 'Checkbox',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Form'), iconName('Input')),
  },
  constraints: {
    pinToParent: true,
  },
  style: {
    base: {
      main: {
        noPseudo: {
          marginTop: px(4),
        },
      },
    },
  },
  showEmpty: false,
  render: withAttribute(
    DATA_ATTR_NODE_TYPE,
    NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_TOGGLE_CHECKBOX
  )(BillingAddressToggleCheckbox),
  fields: {},
});

export default config;
